import React, { useCallback } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { useHeaderConfig } from "../../../NavProvider";
import { logout } from "../../../../../lib/sso";
import { trackMainNavEvent } from "../../analytics";
import { useAuth } from "../../../AuthProvider";
var useStyles = makeStyles(createStyles({
    list: {
        display: "flex",
        flexDirection: "column",
        padding: "8px 0",
        color: "#fff",
        fontSize: "16px",
        lineHeight: "22px",
        textAlign: "right",
        cursor: "default",
    },
    item: {
        display: "inline-block",
        padding: "8px 16px",
        cursor: "pointer",
        userSelect: "none",
        letterSpacing: 0.4,
        "&:hover": {
            fontWeight: "bold",
            letterSpacing: 0.1,
            textShadow: "0 0 #fff",
            WebkitFontSmoothing: "subpixel-antialiased",
        },
        "&::before": {
            display: "block",
            content: "attr(data-title)",
            visibility: "hidden",
            overflow: "hidden",
            height: 0,
            fontWeight: "bold",
            letterSpacing: 0.4,
        },
    },
}));
var SsoMenu = function (_a) {
    var onItemClick = _a.onItemClick;
    var styles = useStyles();
    var _b = useHeaderConfig(), sso = _b.sso, ulm = _b.ulm, uxf = _b.uxf;
    var _c = useAuth(), enableUxf = _c.enableUxf, onLogout = _c.onLogout, shouldOverrideLogout = _c.shouldOverrideLogout;
    var handleManageProfile = useCallback(function () {
        var href = enableUxf ? uxf.logoutUrl : ulm.urlParams.domain + "/profile";
        trackMainNavEvent(sso.manageProfile, href);
        onItemClick();
        window.location.href = href;
    }, [enableUxf, ulm, uxf.logoutUrl, sso.manageProfile, onItemClick]);
    var handleLogout = useCallback(function () {
        trackMainNavEvent(sso.logout);
        if (!shouldOverrideLogout) {
            if (enableUxf) {
                // NOTE: redirect to profile page if in UXF pages
                onItemClick();
                onLogout && onLogout();
                window.location.href = uxf.logoutUrl;
                return;
            }
            else {
                logout();
            }
        }
        onItemClick();
        onLogout && onLogout();
    }, [shouldOverrideLogout, sso.logout, enableUxf, uxf.logoutUrl, onItemClick, onLogout]);
    return (React.createElement("ul", { className: styles.list },
        React.createElement("li", { id: "headerAvatarManageProfile", className: styles.item, onClick: handleManageProfile, "data-title": sso.manageProfile }, sso.manageProfile),
        React.createElement("li", { id: "headerAvatarLogout", className: styles.item, onClick: handleLogout, "data-title": sso.logout }, sso.logout)));
};
export default SsoMenu;
